import React, { useState, useMemo, useEffect } from "react";
import { t } from "i18next";
import TextLabel from "./TextLabel";
import DatatTable from "./TableNoStyle";
import { minutesToHHMMSS } from "./DateUtils";
import Card from "react-bootstrap/Card";
import { CardHeader } from "react-bootstrap";
import ReactModal from "./Modal/AddModalCustomer";
import useAddModal from "../../hooks/useAddModal";
import ShowResolverInfoModal from "./Modal/ShowResolverInfoModal";
import {
  apiHostUrl,
  getUserListfromGroupNameURL,
} from "../../../constants/constants";
import useAxiosFetchData from "../../hooks/useAxiosFetchData";
import { useSelector } from "react-redux";
const tableStyles = {
  width: " 100%",
  height: "auto",
  minWidth: "0",
};

function ResolutionEscalationMatrixTable({ matrixPayload }) {
  const { homeLink } = useSelector((state) => state.role);
  const { isOpen, val, toggleModal } = useAddModal();
  const [row, setRow] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [selectedRowss, setSelectedRowss] = useState([]);
  const { csrfToken } = useSelector((state) => state.csrf);
  const [headers, setHeaders] = useState({
    "X-Csrf-Token": csrfToken,
    "Content-Type": "application/json",
  });
  const [userListFormData, setUserListFormData] = useState(null);
  const { fetchData: userListFeedbackResponse } = useAxiosFetchData({
    url: `${apiHostUrl}${homeLink}${getUserListfromGroupNameURL}`,
    method: "post",
    body: userListFormData,
    headers: headers,
    onLoad: false,
  });
  const columnData = useMemo(
    () => [
      {
        accessorKey: "level",
        header: t("feedbackDetails.level.text"),
        size: 60,

        // render: (row) => (
        //     <input
        //         type="checkbox"
        //         onChange={() => handleCheckboxChange(row.id)}
        //         checked={selectedRowss.includes(row.id)}
        //     />
        // ),
      },
      {
        accessorKey: "grp_name",
        header: t("feedbackDetails.groupName.text"),
        // size: props.size.sl_no,
      },
      {
        accessorKey: "estime",
        header: t("feedbackDetails.escalationTime.text") + "(HH:MM:SS)",

        // size:props.size.f_code,
      },
    ],
    []
  );

  const handleCheckboxChange = (id) => {
    setSelectedRowss((prevSelectedRows) => {
      if (prevSelectedRows.includes(id)) {
        return prevSelectedRows.filter((rowId) => rowId !== id);
      } else {
        return [...prevSelectedRows, id];
      }
    });
  };
  const handleAssigneeView = (e, item) => {
    setUserListFormData({
      department: {id:item.departmentId},
      id: item.asigneeGroupId,
    });
  };
  useEffect(() => {
    if (userListFormData?.department?.id && userListFormData?.id) {
      userListFeedbackResponse().then((data) => {
        console.log(data);
        setRow(data);
        toggleModal();
      });
    }
  }, [userListFormData]);
  useEffect(() => {
    matrixPayload.forEach((item, index) => {
      if (item.escalationStep === 0) return;
      // const checkbox = (
      //     <label>
      //         <input
      //             type="radio"
      //             onChange={() => handleCheckboxChange(item.departmentSlaEscalationId)}
      //             checked={selectedRowss.includes(item.departmentSlaEscalationId)}
      //         />
      //         {item.escalationStep} {/* This will display the value next to the radio button */}
      //     </label>

      // );
      setFilteredRows((prevFilteredRows) => {
        console.log(item);
        return [
          ...prevFilteredRows,
          {
            level: item.escalationStep,
            grp_name: item.asigneeGroupId && (
              <div>
                <span>
                  {item.assigneeGroupName}
                  <i
                    class="ti ti-external-link fs-6 text-primary"
                    aria-hidden="true"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => {console.log("Onclicked");handleAssigneeView(e, item)}}
                  ></i>
                </span>
              </div>
            ),
            estime: minutesToHHMMSS(item.minuteToCalculate),
          },
        ];
      });
    });
  }, []);
  return (
    <Card className="overflow-hidden">
      <ReactModal
        size="sm"
        componentToRender={
          <ShowResolverInfoModal
            open={isOpen}
            handleClose={toggleModal}
            handleUserList={row}
          />
        }
        show={isOpen}
        handleClose={toggleModal}
        title={t("general.label.user.list")}
      />
      <CardHeader className="light-blue-bg">
        <TextLabel title={t("feedbackDetails.escalationMatrix.text")} />
      </CardHeader>
      <DatatTable
        tableStyles={tableStyles}
        tableData={{ columnData, rowsData: filteredRows }}
      />
    </Card>
  );
}

export default ResolutionEscalationMatrixTable;
